module.exports = "/_next/static/pages/profile03/9d9a87c241216541ac0ce7c4d32fe1e7.jpg";